import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Fun surprise: UglifyJS can't ES6",
  "description": "",
  "published": "2016-12-07T00:00:00.000Z",
  "redirect_from": ["/blog/fun-surprise-uglifyjs-cant-es6/swizec/7272"],
  "categories": "Front End, react, Technical",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><em parentName="p">{`"Yo Swiz, why aren't there any generated assets on preprod?"`}</em></p>
    <p>{`Preprod is production-but-not. As the last step before deploying to production, it acts just like the real deal. Real data, real users, real configuration, real everything except payments. Because that would be rude.`}</p>
    <p><em parentName="p">{`"Errr ... what do you mean there's no assets?"`}</em></p>
    <p><em parentName="p">{`"Well, we ran out of environments, so I'm testing on preprod. It's like Webpack doesn't output anything, but it works on localhost and all our other environments."`}</em></p>
    <p>{`O.o`}</p>
    <pre><code parentName="pre" {...{}}>{`ERROR in tutor_onboarding.js from UglifyJs
SyntaxError: Unexpected token: name (defaultHeaders) [./~/better-fetch/index.js:2,0]
`}</code></pre>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2016/12/Screen-Shot-2016-12-07-at-00.15.52.png",
        "alt": null
      }}></img></p>
    <p>{`That's funny ... UglifyJS throws an error on the first line of my `}<a parentName="p" {...{
        "href": "https://swizec.com/blog/a-tiny-es6-fetch-wrapper/swizec/7177"
      }}>{`better-fetch`}</a>{` library. Why would it do `}<em parentName="p">{`that`}</em>{`? ?`}</p>
    <p><em parentName="p">{`"We don't minify our code on localhost, do we? What about on staging?"`}</em></p>
    <p><em parentName="p">{`"Yeah, only prod and preprod"`}</em></p>
    <p>{`Great, at least we know how nobody noticed this in over a month. It only happens on servers configured for production.`}</p>
    <p>{`Thank the-god-of-grizzled-veterans for preprod! Error happens, deploy goes through, assets are empty, nothing works. Imagine how `}<em parentName="p">{`absolutely fantastic`}</em>{` this would be to discover when deploying to real production ?`}</p>
    <p>{`Here's the line that broke `}<a parentName="p" {...{
        "href": "https://github.com/mishoo/UglifyJS2"
      }}>{`UglifyJS`}</a>{`:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`let defaultHeaders = {};
`}</code></pre>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2016/12/i-built-a-sfaehy.jpg",
        "alt": null
      }}></img></p>
    <p>{`I built a `}<inlineCode parentName="p">{`fetch()`}</inlineCode>{` wrapper in ES6. Fuck me, right? Not like it's an ES6+ only API or anything like that…`}</p>
    <blockquote>
      <p parentName="blockquote">{`Hint: it is. It's ES6 only. You'd think building a wrapper in ES6 without compiling before `}<inlineCode parentName="p">{`npm publish`}</inlineCode>{` would work, right?`}</p>
    </blockquote>
    <p>{`Nope. Not if a project that imports your library minifies their assets.`}</p>
    <h2 {...{
      "id": "how-to-package-your-es6-library-so-anyone-can-use-it"
    }}>{`How to package your ES6 library so anyone can use it`}</h2>
    <p>{`3.73 months ago, I thought `}<a parentName="p" {...{
        "href": "https://swizec.com/blog/livecoding-19-its-hard-to-package-a-library/swizec/6927"
      }}>{`packaging a library was hard`}</a>{`. Turns out it's not so bad at all.`}</p>
    <p>{`You have to add `}<a parentName="p" {...{
        "href": "https://babeljs.io/"
      }}>{`Babel`}</a>{`, the ES6 -> ES5 compiler`}<a parentName="p" {...{
        "href": "#fn1"
      }}>{`1`}</a>{`, configure it, update your new `}<inlineCode parentName="p">{`main`}</inlineCode>{` entry, and add a `}<inlineCode parentName="p">{`build`}</inlineCode>{` script to npm scripts. That makes it easier to run.`}</p>
    <p>{`These 7 lines are all it takes: `}<a parentName="p" {...{
        "href": "https://github.com/Swizec/better-fetch/commit/9c7c6e2afc660ea9a35bc73a14d15aedc7f47b04"
      }}>{`diff on Github`}</a></p>
    <p>{`You have to install `}<inlineCode parentName="p">{`babel-cli`}</inlineCode>{` and `}<inlineCode parentName="p">{`babel-preset-latest`}</inlineCode>{`:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`$ npm install --save-dev babel-cli babel-preset-latest
`}</code></pre>
    <p>{`And configure Babel:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`// package.json

"babel": {
    "presets": ["latest"]
}
`}</code></pre>
    <p>{`Configuring in `}<inlineCode parentName="p">{`package.json`}</inlineCode>{` is easiest. 17 characters is not a good enough reason to add another config file to your project.`}</p>
    <p>{`You should update your `}<inlineCode parentName="p">{`main`}</inlineCode>{` entry as well. It tells npm which file to use when somebody uses `}<inlineCode parentName="p">{`require('your-library')`}</inlineCode>{` or `}<inlineCode parentName="p">{`import YourThing from 'your-library'`}</inlineCode>{`.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`// package.json

"main": "lib/index.js"
`}</code></pre>
    <p>{`Many projects use `}<inlineCode parentName="p">{`lib/`}</inlineCode>{` for their compiled files. `}<inlineCode parentName="p">{`dist/`}</inlineCode>{` is another popular choice.`}</p>
    <p>{`To improve your quality of life, you should add a `}<inlineCode parentName="p">{`build`}</inlineCode>{` script. Also in `}<inlineCode parentName="p">{`package.json`}</inlineCode>{`:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`// package.json
"scripts": {
    "build": "babel src -d lib"
}
`}</code></pre>
    <p>{`Now you can use `}<inlineCode parentName="p">{`npm run build`}</inlineCode>{` to run `}<inlineCode parentName="p">{`babel`}</inlineCode>{`, read files from `}<inlineCode parentName="p">{`src/`}</inlineCode>{`, and output the compiled versions in `}<inlineCode parentName="p">{`lib/`}</inlineCode>{`. Library fixed. Crisis solved. `}{`\\`}{`o/`}</p>
    <h2 {...{
      "id": "further-quality-of-life-improvement"
    }}>{`Further quality of life improvement`}</h2>
    <p>{`While heroically saving the day with the above 7 lines of configuration, I found another way to improve my quality of life: automatic version bumping and GitHub pushing.`}</p>
    <p>{`Add these 3 lines to `}<inlineCode parentName="p">{`package.json`}</inlineCode>{`:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`// package.json
"scripts": {
    "preversion": "",
    "version": "npm run build && git add -A lib",
    "postversion": "git push && git push --tags && rm -rf build/temp",
}
`}</code></pre>
    <p>{`You can use `}<inlineCode parentName="p">{`npm version X`}</inlineCode>{` where X is one of `}<inlineCode parentName="p">{`patch`}</inlineCode>{`, `}<inlineCode parentName="p">{`minor`}</inlineCode>{`, `}<inlineCode parentName="p">{`major`}</inlineCode>{`, etc. to bump your library version number. That always works.`}</p>
    <p>{`These three lines make it better. `}<inlineCode parentName="p">{`preversion`}</inlineCode>{` runs a command `}<em parentName="p">{`before`}</em>{` updating the version number. If the command fails, the version doesn't change. Usually these are tests. In my case, it's empty because I'm a bad person.`}</p>
    <p><inlineCode parentName="p">{`version`}</inlineCode>{` runs a command when the version updates. This is a great spot to compile your library and add the compiled files to git.`}</p>
    <p><inlineCode parentName="p">{`postversion`}</inlineCode>{` runs after the version updates. And `}<em parentName="p">{`this`}</em>{` is a great spot to push to GitHub and perform any build cleanup.`}</p>
    <p>{`Now you can update your library then run `}<inlineCode parentName="p">{`npm version patch`}</inlineCode>{` to bump the version, build the lib, and push to github. `}<inlineCode parentName="p">{`npm publish`}</inlineCode>{` announces the fix to the world.`}</p>
    <p>{`Time to congratulate yourself and grab a beverage. ?`}</p>
    <h2 {...{
      "id": "lesson-learned"
    }}>{`Lesson Learned`}</h2>
    <p>{`UglifyJS doesn't support ES6. They've been `}<a parentName="p" {...{
        "href": "https://github.com/mishoo/UglifyJS2/issues/448"
      }}>{`working on it`}</a>{` since at least March of 2014. As of December 6th, 2016, it's still not ready. Turns out this is a hard problem.`}</p>
    <p>{`Most real world projects use UglifyJS to minify their JavaScript.`}</p>
    <p>{`You have to distribute a compiled version of your JavaScript libraries no matter what they do. Such is life.`}</p>
    <hr></hr>
    <ol>
      <li parentName="ol">{`Yes, Babel is `}<em parentName="li">{`technically`}</em>{` a `}<a parentName="li" {...{
          "href": "https://en.wikipedia.org/wiki/Source-to-source_compiler"
        }}>{`transpiler`}</a>{` `}<a parentName="li" {...{
          "href": "#ffn1"
        }}>{`↩`}</a></li>
    </ol>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      